import React from 'react';
import './TransferSuccess.scss';

import {imagePath} from '../index';
/*
import TransferSuccess from './components/TransferSuccess/TransferSuccess';

function App() {
  return (
    <TransferSuccess
      bankName="MoniePoint"
      name="Cyber Coeus"
      accountNumber="1234567891"
      country="United States"
      type="Bank Transfer"
      dateTime="12/09/2025 12:34 PM"
      transactionId="6785847758473"
      amount="$5,000,000.00"
    />
  );
}

export default App;
*/

const TransferFailed = ({
  bankName,
  name,
  accountNumber,
  country,
  type,
  dateTime,
  transactionId,
  status='successful',
  amount
}) => {
  //Transfer to 
  return (
    <div className="transfer-success">
      {/*<header className="header">
        <div className="menu-icon">☰</div>
        <img src="/logo.png" alt="Capitals World" className="logo" />
        <div className="header-icons">
          <span className="notification">🔔</span>
          <span className="profile">👤</span>
        </div>
      </header>*/}

      <div className="transfer-card">
        <img src={`${imagePath}b/logo.svg`} alt="Capitals World" className="card-logo" />
        <h2 className="transfer-title">{name}</h2>
        <h1 className="amount negative">-{amount}</h1>
        <div className={`status-badge ${status}`}>
          Transfer {status.replaceAll('_',' ')||'Successful'}
        </div>
      </div>

      <div className="details-card">
        <h3>Payment Details</h3>
        <div className="details-list">
          <DetailRow label="Bank Name" value={bankName} />
          <DetailRow label="Name" value={name} />
          <DetailRow label="Account Number" value={accountNumber} />
          <DetailRow label="Country" value={country} />
          <DetailRow label="Transaction Type" value={type} />
          <DetailRow label="Date and Time" value={dateTime} />
          <DetailRow label="Transaction ID" value={transactionId} />
        </div>
      </div>

      <div className="footer">
        <p className="footer-text">
          Our Bank helps over 2 million customers achieve their financial goals by helping them save and invest with ease. Put that extra cash to use without putting it at risk with Our Bank.
        </p>
        {/*<p className="copyright">
          Copyright © 2024. All rights reserved.
        </p>*/}
      </div>
    </div>
  );
};

const DetailRow = ({ label, value }) => (
  <div className="detail-row">
    <span className="label">{label}</span>
    <span className="value">{value}</span>
  </div>
);

export default TransferFailed;

